import LogService from './log-service/log.service';

class AntiforgeryService {
  private static token: string | null = null;

  public static async getToken(): Promise<string> {
    if (this.token) {
      return this.token;
    }

    try {
      const response = await fetch('/api/antiforgery/token', {
        method: 'GET',
      }).catch(() => {
        throw Object.assign(new Error('Network request failed'), { name: 'NetworkError' });
      });

      if (!response.ok) {
        throw Object.assign(new Error('Failed to fetch antiforgery token'), { statusCode: response.status });
      }

      const result = (await response.json()) as { token: string | null };
      this.token = result.token;

      if (!this.token) {
        throw new Error('Antiforgery token is null or undefined');
      }
      return this.token;
    } catch (error) {
      LogService.logError(error, 'Error fetching antiforgery token');
      throw error;
    }
  }
}

export default AntiforgeryService;
